import { Header } from "@/components/site/Header";
import { Footer, FooterCTA } from "@/components/site/Footer";
import { MobileStickyCTA } from "@/components/site/MobileStickyCTA";

export function PublicLayout({ children, hideFooterCTA }) {
  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <Header />
      <main className="flex-1 pb-16 lg:pb-0">{children}</main>
      {!hideFooterCTA && <FooterCTA />}
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
